var cov_1kzso1457z = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/color.ts",
      hash = "932d613e1f844079be65e6f2f9c31d9ddd176b53",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/color.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 20
        },
        end: {
          line: 6,
          column: 35
        }
      },
      "1": {
        start: {
          line: 9,
          column: 19
        },
        end: {
          line: 9,
          column: 41
        }
      },
      "2": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 55
        }
      },
      "3": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 101
        }
      },
      "4": {
        start: {
          line: 14,
          column: 26
        },
        end: {
          line: 14,
          column: 122
        }
      },
      "5": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 22
        }
      },
      "6": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "7": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 26
        }
      },
      "8": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 33
        }
      },
      "9": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "10": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 29
        }
      },
      "11": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "12": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 52
        }
      },
      "13": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "14": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 65
        }
      },
      "15": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "16": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "17": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "18": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "19": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "20": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "21": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 80,
          column: 3
        }
      },
      "22": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "23": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 81,
          column: 14
        }
      },
      "24": {
        start: {
          line: 84,
          column: 14
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "25": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 85,
          column: 52
        }
      },
      "26": {
        start: {
          line: 85,
          column: 43
        },
        end: {
          line: 85,
          column: 52
        }
      },
      "27": {
        start: {
          line: 86,
          column: 16
        },
        end: {
          line: 86,
          column: 28
        }
      },
      "28": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 87,
          column: 23
        }
      },
      "29": {
        start: {
          line: 87,
          column: 14
        },
        end: {
          line: 87,
          column: 23
        }
      },
      "30": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 112
        }
      },
      "31": {
        start: {
          line: 91,
          column: 17
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "32": {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "33": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 50
        }
      },
      "34": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 16
        }
      },
      "35": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 100,
          column: 3
        }
      },
      "36": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 82
        }
      },
      "37": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 16
        }
      },
      "38": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 13
        }
      },
      "39": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "40": {
        start: {
          line: 105,
          column: 14
        },
        end: {
          line: 105,
          column: 31
        }
      },
      "41": {
        start: {
          line: 106,
          column: 14
        },
        end: {
          line: 106,
          column: 21
        }
      },
      "42": {
        start: {
          line: 107,
          column: 2
        },
        end: {
          line: 107,
          column: 46
        }
      },
      "43": {
        start: {
          line: 107,
          column: 21
        },
        end: {
          line: 107,
          column: 46
        }
      },
      "44": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 12
        }
      },
      "45": {
        start: {
          line: 115,
          column: 17
        },
        end: {
          line: 115,
          column: 55
        }
      },
      "46": {
        start: {
          line: 115,
          column: 36
        },
        end: {
          line: 115,
          column: 55
        }
      },
      "47": {
        start: {
          line: 121,
          column: 23
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "48": {
        start: {
          line: 122,
          column: 2
        },
        end: {
          line: 122,
          column: 72
        }
      },
      "49": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 72
        }
      },
      "50": {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 123,
          column: 105
        }
      },
      "51": {
        start: {
          line: 123,
          column: 20
        },
        end: {
          line: 123,
          column: 105
        }
      },
      "52": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 124,
          column: 87
        }
      },
      "53": {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 124,
          column: 87
        }
      },
      "54": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 125,
          column: 113
        }
      },
      "55": {
        start: {
          line: 128,
          column: 15
        },
        end: {
          line: 131,
          column: 1
        }
      },
      "56": {
        start: {
          line: 129,
          column: 16
        },
        end: {
          line: 129,
          column: 43
        }
      },
      "57": {
        start: {
          line: 130,
          column: 2
        },
        end: {
          line: 130,
          column: 83
        }
      },
      "58": {
        start: {
          line: 133,
          column: 16
        },
        end: {
          line: 138,
          column: 1
        }
      },
      "59": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 43
        }
      },
      "60": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 137,
          column: 6
        }
      },
      "61": {
        start: {
          line: 140,
          column: 18
        },
        end: {
          line: 160,
          column: 1
        }
      },
      "62": {
        start: {
          line: 141,
          column: 2
        },
        end: {
          line: 143,
          column: 3
        }
      },
      "63": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 16
        }
      },
      "64": {
        start: {
          line: 145,
          column: 25
        },
        end: {
          line: 145,
          column: 39
        }
      },
      "65": {
        start: {
          line: 146,
          column: 2
        },
        end: {
          line: 146,
          column: 61
        }
      },
      "66": {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 151,
          column: 3
        }
      },
      "67": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 47
        }
      },
      "68": {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 156,
          column: 3
        }
      },
      "69": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 12
        }
      },
      "70": {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 159,
          column: 48
        }
      },
      "71": {
        start: {
          line: 162,
          column: 17
        },
        end: {
          line: 169,
          column: 1
        }
      },
      "72": {
        start: {
          line: 163,
          column: 2
        },
        end: {
          line: 163,
          column: 19
        }
      },
      "73": {
        start: {
          line: 163,
          column: 13
        },
        end: {
          line: 163,
          column: 19
        }
      },
      "74": {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 164,
          column: 19
        }
      },
      "75": {
        start: {
          line: 164,
          column: 13
        },
        end: {
          line: 164,
          column: 19
        }
      },
      "76": {
        start: {
          line: 165,
          column: 2
        },
        end: {
          line: 165,
          column: 43
        }
      },
      "77": {
        start: {
          line: 165,
          column: 17
        },
        end: {
          line: 165,
          column: 43
        }
      },
      "78": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 166,
          column: 25
        }
      },
      "79": {
        start: {
          line: 166,
          column: 17
        },
        end: {
          line: 166,
          column: 25
        }
      },
      "80": {
        start: {
          line: 167,
          column: 2
        },
        end: {
          line: 167,
          column: 53
        }
      },
      "81": {
        start: {
          line: 167,
          column: 17
        },
        end: {
          line: 167,
          column: 53
        }
      },
      "82": {
        start: {
          line: 168,
          column: 2
        },
        end: {
          line: 168,
          column: 10
        }
      },
      "83": {
        start: {
          line: 171,
          column: 21
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "84": {
        start: {
          line: 172,
          column: 27
        },
        end: {
          line: 172,
          column: 33
        }
      },
      "85": {
        start: {
          line: 178,
          column: 2
        },
        end: {
          line: 178,
          column: 23
        }
      },
      "86": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 179,
          column: 23
        }
      },
      "87": {
        start: {
          line: 180,
          column: 2
        },
        end: {
          line: 180,
          column: 23
        }
      },
      "88": {
        start: {
          line: 182,
          column: 2
        },
        end: {
          line: 192,
          column: 3
        }
      },
      "89": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 183,
          column: 9
        }
      },
      "90": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 9
        }
      },
      "91": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 9
        }
      },
      "92": {
        start: {
          line: 187,
          column: 14
        },
        end: {
          line: 187,
          column: 51
        }
      },
      "93": {
        start: {
          line: 188,
          column: 14
        },
        end: {
          line: 188,
          column: 23
        }
      },
      "94": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 189,
          column: 33
        }
      },
      "95": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 25
        }
      },
      "96": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 191,
          column: 33
        }
      },
      "97": {
        start: {
          line: 194,
          column: 2
        },
        end: {
          line: 194,
          column: 20
        }
      },
      "98": {
        start: {
          line: 195,
          column: 2
        },
        end: {
          line: 195,
          column: 20
        }
      },
      "99": {
        start: {
          line: 196,
          column: 2
        },
        end: {
          line: 196,
          column: 20
        }
      },
      "100": {
        start: {
          line: 198,
          column: 2
        },
        end: {
          line: 198,
          column: 69
        }
      },
      "101": {
        start: {
          line: 201,
          column: 18
        },
        end: {
          line: 210,
          column: 1
        }
      },
      "102": {
        start: {
          line: 202,
          column: 17
        },
        end: {
          line: 202,
          column: 64
        }
      },
      "103": {
        start: {
          line: 203,
          column: 2
        },
        end: {
          line: 206,
          column: 3
        }
      },
      "104": {
        start: {
          line: 204,
          column: 31
        },
        end: {
          line: 204,
          column: 37
        }
      },
      "105": {
        start: {
          line: 205,
          column: 4
        },
        end: {
          line: 205,
          column: 74
        }
      },
      "106": {
        start: {
          line: 208,
          column: 2
        },
        end: {
          line: 208,
          column: 72
        }
      },
      "107": {
        start: {
          line: 209,
          column: 2
        },
        end: {
          line: 209,
          column: 18
        }
      },
      "108": {
        start: {
          line: 212,
          column: 14
        },
        end: {
          line: 229,
          column: 1
        }
      },
      "109": {
        start: {
          line: 213,
          column: 27
        },
        end: {
          line: 213,
          column: 30
        }
      },
      "110": {
        start: {
          line: 214,
          column: 3
        },
        end: {
          line: 214,
          column: 20
        }
      },
      "111": {
        start: {
          line: 217,
          column: 19
        },
        end: {
          line: 217,
          column: 32
        }
      },
      "112": {
        start: {
          line: 218,
          column: 2
        },
        end: {
          line: 218,
          column: 27
        }
      },
      "113": {
        start: {
          line: 219,
          column: 2
        },
        end: {
          line: 219,
          column: 27
        }
      },
      "114": {
        start: {
          line: 220,
          column: 2
        },
        end: {
          line: 220,
          column: 27
        }
      },
      "115": {
        start: {
          line: 222,
          column: 2
        },
        end: {
          line: 222,
          column: 33
        }
      },
      "116": {
        start: {
          line: 222,
          column: 22
        },
        end: {
          line: 222,
          column: 33
        }
      },
      "117": {
        start: {
          line: 223,
          column: 2
        },
        end: {
          line: 223,
          column: 33
        }
      },
      "118": {
        start: {
          line: 223,
          column: 22
        },
        end: {
          line: 223,
          column: 33
        }
      },
      "119": {
        start: {
          line: 224,
          column: 2
        },
        end: {
          line: 224,
          column: 33
        }
      },
      "120": {
        start: {
          line: 224,
          column: 22
        },
        end: {
          line: 224,
          column: 33
        }
      },
      "121": {
        start: {
          line: 226,
          column: 2
        },
        end: {
          line: 226,
          column: 47
        }
      },
      "122": {
        start: {
          line: 226,
          column: 16
        },
        end: {
          line: 226,
          column: 47
        }
      },
      "123": {
        start: {
          line: 228,
          column: 2
        },
        end: {
          line: 228,
          column: 57
        }
      },
      "124": {
        start: {
          line: 232,
          column: 14
        },
        end: {
          line: 274,
          column: 1
        }
      },
      "125": {
        start: {
          line: 233,
          column: 20
        },
        end: {
          line: 233,
          column: 23
        }
      },
      "126": {
        start: {
          line: 235,
          column: 2
        },
        end: {
          line: 235,
          column: 23
        }
      },
      "127": {
        start: {
          line: 236,
          column: 2
        },
        end: {
          line: 236,
          column: 23
        }
      },
      "128": {
        start: {
          line: 237,
          column: 2
        },
        end: {
          line: 237,
          column: 23
        }
      },
      "129": {
        start: {
          line: 239,
          column: 14
        },
        end: {
          line: 239,
          column: 31
        }
      },
      "130": {
        start: {
          line: 240,
          column: 14
        },
        end: {
          line: 240,
          column: 31
        }
      },
      "131": {
        start: {
          line: 243,
          column: 10
        },
        end: {
          line: 243,
          column: 25
        }
      },
      "132": {
        start: {
          line: 245,
          column: 2
        },
        end: {
          line: 267,
          column: 3
        }
      },
      "133": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 9
        }
      },
      "134": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 9
        }
      },
      "135": {
        start: {
          line: 249,
          column: 14
        },
        end: {
          line: 249,
          column: 23
        }
      },
      "136": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 250,
          column: 55
        }
      },
      "137": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 264,
          column: 5
        }
      },
      "138": {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 253,
          column: 41
        }
      },
      "139": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 13
        }
      },
      "140": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 256,
          column: 27
        }
      },
      "141": {
        start: {
          line: 257,
          column: 8
        },
        end: {
          line: 257,
          column: 13
        }
      },
      "142": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 259,
          column: 27
        }
      },
      "143": {
        start: {
          line: 260,
          column: 8
        },
        end: {
          line: 260,
          column: 13
        }
      },
      "144": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 13
        }
      },
      "145": {
        start: {
          line: 263,
          column: 8
        },
        end: {
          line: 263,
          column: 13
        }
      },
      "146": {
        start: {
          line: 266,
          column: 4
        },
        end: {
          line: 266,
          column: 10
        }
      },
      "147": {
        start: {
          line: 269,
          column: 2
        },
        end: {
          line: 269,
          column: 20
        }
      },
      "148": {
        start: {
          line: 270,
          column: 2
        },
        end: {
          line: 270,
          column: 20
        }
      },
      "149": {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 271,
          column: 20
        }
      },
      "150": {
        start: {
          line: 273,
          column: 2
        },
        end: {
          line: 273,
          column: 69
        }
      },
      "151": {
        start: {
          line: 275,
          column: 20
        },
        end: {
          line: 294,
          column: 1
        }
      },
      "152": {
        start: {
          line: 275,
          column: 110
        },
        end: {
          line: 294,
          column: 1
        }
      },
      "153": {
        start: {
          line: 279,
          column: 2
        },
        end: {
          line: 279,
          column: 31
        }
      },
      "154": {
        start: {
          line: 279,
          column: 22
        },
        end: {
          line: 279,
          column: 31
        }
      },
      "155": {
        start: {
          line: 282,
          column: 2
        },
        end: {
          line: 282,
          column: 30
        }
      },
      "156": {
        start: {
          line: 283,
          column: 2
        },
        end: {
          line: 285,
          column: 3
        }
      },
      "157": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 34
        }
      },
      "158": {
        start: {
          line: 287,
          column: 2
        },
        end: {
          line: 287,
          column: 31
        }
      },
      "159": {
        start: {
          line: 288,
          column: 2
        },
        end: {
          line: 290,
          column: 3
        }
      },
      "160": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 289,
          column: 53
        }
      },
      "161": {
        start: {
          line: 292,
          column: 2
        },
        end: {
          line: 292,
          column: 68
        }
      },
      "162": {
        start: {
          line: 293,
          column: 2
        },
        end: {
          line: 293,
          column: 11
        }
      },
      "163": {
        start: {
          line: 297,
          column: 2
        },
        end: {
          line: 297,
          column: 31
        }
      },
      "164": {
        start: {
          line: 297,
          column: 22
        },
        end: {
          line: 297,
          column: 31
        }
      },
      "165": {
        start: {
          line: 301,
          column: 2
        },
        end: {
          line: 301,
          column: 31
        }
      },
      "166": {
        start: {
          line: 302,
          column: 2
        },
        end: {
          line: 304,
          column: 3
        }
      },
      "167": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 303,
          column: 28
        }
      },
      "168": {
        start: {
          line: 306,
          column: 2
        },
        end: {
          line: 306,
          column: 31
        }
      },
      "169": {
        start: {
          line: 307,
          column: 2
        },
        end: {
          line: 309,
          column: 3
        }
      },
      "170": {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 308,
          column: 28
        }
      },
      "171": {
        start: {
          line: 311,
          column: 2
        },
        end: {
          line: 311,
          column: 31
        }
      },
      "172": {
        start: {
          line: 312,
          column: 2
        },
        end: {
          line: 314,
          column: 3
        }
      },
      "173": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 29
        }
      },
      "174": {
        start: {
          line: 316,
          column: 2
        },
        end: {
          line: 316,
          column: 31
        }
      },
      "175": {
        start: {
          line: 317,
          column: 2
        },
        end: {
          line: 319,
          column: 3
        }
      },
      "176": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 29
        }
      },
      "177": {
        start: {
          line: 321,
          column: 2
        },
        end: {
          line: 321,
          column: 68
        }
      },
      "178": {
        start: {
          line: 322,
          column: 2
        },
        end: {
          line: 322,
          column: 11
        }
      },
      "179": {
        start: {
          line: 326,
          column: 2
        },
        end: {
          line: 326,
          column: 31
        }
      },
      "180": {
        start: {
          line: 326,
          column: 22
        },
        end: {
          line: 326,
          column: 31
        }
      },
      "181": {
        start: {
          line: 330,
          column: 2
        },
        end: {
          line: 330,
          column: 30
        }
      },
      "182": {
        start: {
          line: 331,
          column: 2
        },
        end: {
          line: 333,
          column: 3
        }
      },
      "183": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 332,
          column: 31
        }
      },
      "184": {
        start: {
          line: 335,
          column: 2
        },
        end: {
          line: 335,
          column: 31
        }
      },
      "185": {
        start: {
          line: 336,
          column: 2
        },
        end: {
          line: 338,
          column: 3
        }
      },
      "186": {
        start: {
          line: 337,
          column: 4
        },
        end: {
          line: 337,
          column: 42
        }
      },
      "187": {
        start: {
          line: 340,
          column: 2
        },
        end: {
          line: 340,
          column: 68
        }
      },
      "188": {
        start: {
          line: 341,
          column: 2
        },
        end: {
          line: 341,
          column: 11
        }
      },
      "189": {
        start: {
          line: 344,
          column: 24
        },
        end: {
          line: 344,
          column: 42
        }
      },
      "190": {
        start: {
          line: 345,
          column: 24
        },
        end: {
          line: 345,
          column: 42
        }
      },
      "191": {
        start: {
          line: 348,
          column: 15
        },
        end: {
          line: 348,
          column: 28
        }
      },
      "192": {
        start: {
          line: 349,
          column: 2
        },
        end: {
          line: 349,
          column: 22
        }
      },
      "193": {
        start: {
          line: 349,
          column: 13
        },
        end: {
          line: 349,
          column: 22
        }
      },
      "194": {
        start: {
          line: 350,
          column: 2
        },
        end: {
          line: 350,
          column: 23
        }
      },
      "195": {
        start: {
          line: 354,
          column: 15
        },
        end: {
          line: 354,
          column: 28
        }
      },
      "196": {
        start: {
          line: 355,
          column: 2
        },
        end: {
          line: 355,
          column: 22
        }
      },
      "197": {
        start: {
          line: 355,
          column: 13
        },
        end: {
          line: 355,
          column: 22
        }
      },
      "198": {
        start: {
          line: 356,
          column: 2
        },
        end: {
          line: 356,
          column: 32
        }
      },
      "199": {
        start: {
          line: 362,
          column: 2
        },
        end: {
          line: 362,
          column: 40
        }
      },
      "200": {
        start: {
          line: 362,
          column: 24
        },
        end: {
          line: 362,
          column: 40
        }
      },
      "201": {
        start: {
          line: 364,
          column: 18
        },
        end: {
          line: 364,
          column: 23
        }
      },
      "202": {
        start: {
          line: 366,
          column: 2
        },
        end: {
          line: 368,
          column: 3
        }
      },
      "203": {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 367,
          column: 31
        }
      },
      "204": {
        start: {
          line: 370,
          column: 2
        },
        end: {
          line: 372,
          column: 3
        }
      },
      "205": {
        start: {
          line: 371,
          column: 4
        },
        end: {
          line: 371,
          column: 31
        }
      },
      "206": {
        start: {
          line: 374,
          column: 2
        },
        end: {
          line: 374,
          column: 29
        }
      },
      "207": {
        start: {
          line: 378,
          column: 17
        },
        end: {
          line: 378,
          column: 33
        }
      },
      "208": {
        start: {
          line: 379,
          column: 2
        },
        end: {
          line: 379,
          column: 40
        }
      },
      "209": {
        start: {
          line: 379,
          column: 28
        },
        end: {
          line: 379,
          column: 40
        }
      },
      "210": {
        start: {
          line: 380,
          column: 2
        },
        end: {
          line: 380,
          column: 15
        }
      },
      "211": {
        start: {
          line: 384,
          column: 17
        },
        end: {
          line: 384,
          column: 33
        }
      },
      "212": {
        start: {
          line: 385,
          column: 2
        },
        end: {
          line: 385,
          column: 40
        }
      },
      "213": {
        start: {
          line: 385,
          column: 28
        },
        end: {
          line: 385,
          column: 40
        }
      },
      "214": {
        start: {
          line: 386,
          column: 2
        },
        end: {
          line: 386,
          column: 16
        }
      },
      "215": {
        start: {
          line: 394,
          column: 17
        },
        end: {
          line: 394,
          column: 86
        }
      },
      "216": {
        start: {
          line: 395,
          column: 2
        },
        end: {
          line: 395,
          column: 20
        }
      },
      "217": {
        start: {
          line: 396,
          column: 12
        },
        end: {
          line: 396,
          column: 21
        }
      },
      "218": {
        start: {
          line: 397,
          column: 12
        },
        end: {
          line: 397,
          column: 21
        }
      },
      "219": {
        start: {
          line: 398,
          column: 12
        },
        end: {
          line: 398,
          column: 21
        }
      },
      "220": {
        start: {
          line: 399,
          column: 12
        },
        end: {
          line: 399,
          column: 44
        }
      },
      "221": {
        start: {
          line: 400,
          column: 2
        },
        end: {
          line: 400,
          column: 40
        }
      },
      "222": {
        start: {
          line: 409,
          column: 2
        },
        end: {
          line: 409,
          column: 23
        }
      },
      "223": {
        start: {
          line: 409,
          column: 14
        },
        end: {
          line: 409,
          column: 23
        }
      },
      "224": {
        start: {
          line: 410,
          column: 2
        },
        end: {
          line: 410,
          column: 23
        }
      },
      "225": {
        start: {
          line: 410,
          column: 14
        },
        end: {
          line: 410,
          column: 23
        }
      },
      "226": {
        start: {
          line: 411,
          column: 2
        },
        end: {
          line: 411,
          column: 37
        }
      },
      "227": {
        start: {
          line: 412,
          column: 2
        },
        end: {
          line: 412,
          column: 22
        }
      },
      "228": {
        start: {
          line: 413,
          column: 14
        },
        end: {
          line: 413,
          column: 29
        }
      },
      "229": {
        start: {
          line: 414,
          column: 25
        },
        end: {
          line: 414,
          column: 37
        }
      },
      "230": {
        start: {
          line: 415,
          column: 2
        },
        end: {
          line: 415,
          column: 56
        }
      },
      "231": {
        start: {
          line: 424,
          column: 2
        },
        end: {
          line: 424,
          column: 23
        }
      },
      "232": {
        start: {
          line: 424,
          column: 14
        },
        end: {
          line: 424,
          column: 23
        }
      },
      "233": {
        start: {
          line: 425,
          column: 2
        },
        end: {
          line: 425,
          column: 22
        }
      },
      "234": {
        start: {
          line: 426,
          column: 14
        },
        end: {
          line: 426,
          column: 29
        }
      },
      "235": {
        start: {
          line: 427,
          column: 22
        },
        end: {
          line: 427,
          column: 34
        }
      },
      "236": {
        start: {
          line: 428,
          column: 2
        },
        end: {
          line: 428,
          column: 52
        }
      }
    },
    fnMap: {
      "0": {
        name: "parseIntFromHex",
        decl: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 38
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 33
      },
      "1": {
        name: "convertHexToDecimal",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 28
          }
        },
        loc: {
          start: {
            line: 37,
            column: 40
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 14
          },
          end: {
            line: 42,
            column: 15
          }
        },
        loc: {
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 82,
            column: 1
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 84,
            column: 14
          },
          end: {
            line: 84,
            column: 15
          }
        },
        loc: {
          start: {
            line: 84,
            column: 33
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 84
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 91,
            column: 17
          },
          end: {
            line: 91,
            column: 18
          }
        },
        loc: {
          start: {
            line: 91,
            column: 37
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 91
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 104,
            column: 23
          }
        },
        loc: {
          start: {
            line: 104,
            column: 42
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 104
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 115,
            column: 17
          },
          end: {
            line: 115,
            column: 18
          }
        },
        loc: {
          start: {
            line: 115,
            column: 36
          },
          end: {
            line: 115,
            column: 55
          }
        },
        line: 115
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 121,
            column: 23
          },
          end: {
            line: 121,
            column: 24
          }
        },
        loc: {
          start: {
            line: 121,
            column: 60
          },
          end: {
            line: 126,
            column: 1
          }
        },
        line: 121
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 128,
            column: 15
          },
          end: {
            line: 128,
            column: 16
          }
        },
        loc: {
          start: {
            line: 128,
            column: 50
          },
          end: {
            line: 131,
            column: 1
          }
        },
        line: 128
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 133,
            column: 16
          },
          end: {
            line: 133,
            column: 17
          }
        },
        loc: {
          start: {
            line: 133,
            column: 51
          },
          end: {
            line: 138,
            column: 1
          }
        },
        line: 133
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 140,
            column: 18
          },
          end: {
            line: 140,
            column: 19
          }
        },
        loc: {
          start: {
            line: 140,
            column: 57
          },
          end: {
            line: 160,
            column: 1
          }
        },
        line: 140
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 162,
            column: 17
          },
          end: {
            line: 162,
            column: 18
          }
        },
        loc: {
          start: {
            line: 162,
            column: 54
          },
          end: {
            line: 169,
            column: 1
          }
        },
        line: 162
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 171,
            column: 21
          },
          end: {
            line: 171,
            column: 22
          }
        },
        loc: {
          start: {
            line: 171,
            column: 71
          },
          end: {
            line: 199,
            column: 1
          }
        },
        line: 171
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 201,
            column: 18
          },
          end: {
            line: 201,
            column: 19
          }
        },
        loc: {
          start: {
            line: 201,
            column: 37
          },
          end: {
            line: 210,
            column: 1
          }
        },
        line: 201
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 212,
            column: 14
          },
          end: {
            line: 212,
            column: 15
          }
        },
        loc: {
          start: {
            line: 212,
            column: 62
          },
          end: {
            line: 229,
            column: 1
          }
        },
        line: 212
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 232,
            column: 14
          },
          end: {
            line: 232,
            column: 15
          }
        },
        loc: {
          start: {
            line: 232,
            column: 52
          },
          end: {
            line: 274,
            column: 1
          }
        },
        line: 232
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 275,
            column: 20
          },
          end: {
            line: 275,
            column: 21
          }
        },
        loc: {
          start: {
            line: 275,
            column: 110
          },
          end: {
            line: 294,
            column: 1
          }
        },
        line: 275
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 275,
            column: 110
          },
          end: {
            line: 275,
            column: 111
          }
        },
        loc: {
          start: {
            line: 278,
            column: 5
          },
          end: {
            line: 294,
            column: 1
          }
        },
        line: 278
      },
      "18": {
        name: "hexToRgb",
        decl: {
          start: {
            line: 296,
            column: 16
          },
          end: {
            line: 296,
            column: 24
          }
        },
        loc: {
          start: {
            line: 296,
            column: 38
          },
          end: {
            line: 323,
            column: 1
          }
        },
        line: 296
      },
      "19": {
        name: "hslToRgb",
        decl: {
          start: {
            line: 325,
            column: 16
          },
          end: {
            line: 325,
            column: 24
          }
        },
        loc: {
          start: {
            line: 325,
            column: 38
          },
          end: {
            line: 342,
            column: 1
          }
        },
        line: 325
      },
      "20": {
        name: "hexToHsl",
        decl: {
          start: {
            line: 347,
            column: 16
          },
          end: {
            line: 347,
            column: 24
          }
        },
        loc: {
          start: {
            line: 347,
            column: 38
          },
          end: {
            line: 351,
            column: 1
          }
        },
        line: 347
      },
      "21": {
        name: "hslToHex",
        decl: {
          start: {
            line: 353,
            column: 16
          },
          end: {
            line: 353,
            column: 24
          }
        },
        loc: {
          start: {
            line: 353,
            column: 57
          },
          end: {
            line: 357,
            column: 1
          }
        },
        line: 353
      },
      "22": {
        name: "judgeDark",
        decl: {
          start: {
            line: 361,
            column: 16
          },
          end: {
            line: 361,
            column: 25
          }
        },
        loc: {
          start: {
            line: 361,
            column: 41
          },
          end: {
            line: 375,
            column: 1
          }
        },
        line: 361
      },
      "23": {
        name: "isDark",
        decl: {
          start: {
            line: 377,
            column: 16
          },
          end: {
            line: 377,
            column: 22
          }
        },
        loc: {
          start: {
            line: 377,
            column: 38
          },
          end: {
            line: 381,
            column: 1
          }
        },
        line: 377
      },
      "24": {
        name: "isLight",
        decl: {
          start: {
            line: 383,
            column: 16
          },
          end: {
            line: 383,
            column: 23
          }
        },
        loc: {
          start: {
            line: 383,
            column: 39
          },
          end: {
            line: 387,
            column: 1
          }
        },
        line: 383
      },
      "25": {
        name: "getHSLA",
        decl: {
          start: {
            line: 393,
            column: 9
          },
          end: {
            line: 393,
            column: 16
          }
        },
        loc: {
          start: {
            line: 393,
            column: 32
          },
          end: {
            line: 401,
            column: 1
          }
        },
        line: 393
      },
      "26": {
        name: "darken",
        decl: {
          start: {
            line: 408,
            column: 16
          },
          end: {
            line: 408,
            column: 22
          }
        },
        loc: {
          start: {
            line: 408,
            column: 62
          },
          end: {
            line: 416,
            column: 1
          }
        },
        line: 408
      },
      "27": {
        name: "fade",
        decl: {
          start: {
            line: 423,
            column: 16
          },
          end: {
            line: 423,
            column: 20
          }
        },
        loc: {
          start: {
            line: 423,
            column: 47
          },
          end: {
            line: 429,
            column: 1
          }
        },
        line: 423
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        }],
        line: 45
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }, {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }, {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }],
        line: 59
      },
      "4": {
        loc: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }, {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }],
        line: 66
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        }, {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 52
          }
        }, {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 52
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 12
          }
        }, {
          start: {
            line: 85,
            column: 16
          },
          end: {
            line: 85,
            column: 41
          }
        }],
        line: 85
      },
      "8": {
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 23
          }
        }, {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 23
          }
        }],
        line: 87
      },
      "9": {
        loc: {
          start: {
            line: 88,
            column: 9
          },
          end: {
            line: 88,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 19
          },
          end: {
            line: 88,
            column: 70
          }
        }, {
          start: {
            line: 88,
            column: 73
          },
          end: {
            line: 88,
            column: 112
          }
        }],
        line: 88
      },
      "10": {
        loc: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }, {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }],
        line: 92
      },
      "11": {
        loc: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        }, {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        }],
        line: 97
      },
      "12": {
        loc: {
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 46
          }
        }, {
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 46
          }
        }],
        line: 107
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 72
          }
        }, {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 72
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 105
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 105
          }
        }, {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 105
          }
        }],
        line: 123
      },
      "15": {
        loc: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 87
          }
        }, {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 87
          }
        }],
        line: 124
      },
      "16": {
        loc: {
          start: {
            line: 141,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        }, {
          start: {
            line: 141,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        }],
        line: 141
      },
      "17": {
        loc: {
          start: {
            line: 149,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        }, {
          start: {
            line: 149,
            column: 2
          },
          end: {
            line: 151,
            column: 3
          }
        }],
        line: 149
      },
      "18": {
        loc: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        }, {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        }],
        line: 154
      },
      "19": {
        loc: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 19
          }
        }, {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 19
          }
        }],
        line: 163
      },
      "20": {
        loc: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 19
          }
        }, {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 19
          }
        }],
        line: 164
      },
      "21": {
        loc: {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 43
          }
        }, {
          start: {
            line: 165,
            column: 2
          },
          end: {
            line: 165,
            column: 43
          }
        }],
        line: 165
      },
      "22": {
        loc: {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 25
          }
        }, {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 25
          }
        }],
        line: 166
      },
      "23": {
        loc: {
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 53
          }
        }, {
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 53
          }
        }],
        line: 167
      },
      "24": {
        loc: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 192,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 192,
            column: 3
          }
        }, {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 192,
            column: 3
          }
        }],
        line: 182
      },
      "25": {
        loc: {
          start: {
            line: 187,
            column: 14
          },
          end: {
            line: 187,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 187,
            column: 24
          },
          end: {
            line: 187,
            column: 35
          }
        }, {
          start: {
            line: 187,
            column: 38
          },
          end: {
            line: 187,
            column: 51
          }
        }],
        line: 187
      },
      "26": {
        loc: {
          start: {
            line: 198,
            column: 9
          },
          end: {
            line: 198,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 198,
            column: 43
          }
        }, {
          start: {
            line: 198,
            column: 46
          },
          end: {
            line: 198,
            column: 69
          }
        }],
        line: 198
      },
      "27": {
        loc: {
          start: {
            line: 202,
            column: 17
          },
          end: {
            line: 202,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 17
          },
          end: {
            line: 202,
            column: 38
          }
        }, {
          start: {
            line: 202,
            column: 42
          },
          end: {
            line: 202,
            column: 64
          }
        }],
        line: 202
      },
      "28": {
        loc: {
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        }, {
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        }],
        line: 203
      },
      "29": {
        loc: {
          start: {
            line: 217,
            column: 19
          },
          end: {
            line: 217,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 217,
            column: 19
          },
          end: {
            line: 217,
            column: 27
          }
        }, {
          start: {
            line: 217,
            column: 31
          },
          end: {
            line: 217,
            column: 32
          }
        }],
        line: 217
      },
      "30": {
        loc: {
          start: {
            line: 222,
            column: 2
          },
          end: {
            line: 222,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 222,
            column: 2
          },
          end: {
            line: 222,
            column: 33
          }
        }, {
          start: {
            line: 222,
            column: 2
          },
          end: {
            line: 222,
            column: 33
          }
        }],
        line: 222
      },
      "31": {
        loc: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 33
          }
        }, {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 33
          }
        }],
        line: 223
      },
      "32": {
        loc: {
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 33
          }
        }, {
          start: {
            line: 224,
            column: 2
          },
          end: {
            line: 224,
            column: 33
          }
        }],
        line: 224
      },
      "33": {
        loc: {
          start: {
            line: 226,
            column: 2
          },
          end: {
            line: 226,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 226,
            column: 2
          },
          end: {
            line: 226,
            column: 47
          }
        }, {
          start: {
            line: 226,
            column: 2
          },
          end: {
            line: 226,
            column: 47
          }
        }],
        line: 226
      },
      "34": {
        loc: {
          start: {
            line: 228,
            column: 9
          },
          end: {
            line: 228,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 228,
            column: 20
          },
          end: {
            line: 228,
            column: 39
          }
        }, {
          start: {
            line: 228,
            column: 42
          },
          end: {
            line: 228,
            column: 57
          }
        }],
        line: 228
      },
      "35": {
        loc: {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        }, {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        }],
        line: 245
      },
      "36": {
        loc: {
          start: {
            line: 250,
            column: 8
          },
          end: {
            line: 250,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 250,
            column: 18
          },
          end: {
            line: 250,
            column: 37
          }
        }, {
          start: {
            line: 250,
            column: 40
          },
          end: {
            line: 250,
            column: 55
          }
        }],
        line: 250
      },
      "37": {
        loc: {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 264,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 254,
            column: 13
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 257,
            column: 13
          }
        }, {
          start: {
            line: 258,
            column: 6
          },
          end: {
            line: 260,
            column: 13
          }
        }, {
          start: {
            line: 261,
            column: 6
          },
          end: {
            line: 263,
            column: 13
          }
        }],
        line: 251
      },
      "38": {
        loc: {
          start: {
            line: 253,
            column: 27
          },
          end: {
            line: 253,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 253,
            column: 35
          },
          end: {
            line: 253,
            column: 36
          }
        }, {
          start: {
            line: 253,
            column: 39
          },
          end: {
            line: 253,
            column: 40
          }
        }],
        line: 253
      },
      "39": {
        loc: {
          start: {
            line: 273,
            column: 9
          },
          end: {
            line: 273,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 273,
            column: 13
          },
          end: {
            line: 273,
            column: 43
          }
        }, {
          start: {
            line: 273,
            column: 46
          },
          end: {
            line: 273,
            column: 69
          }
        }],
        line: 273
      },
      "40": {
        loc: {
          start: {
            line: 279,
            column: 2
          },
          end: {
            line: 279,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 279,
            column: 2
          },
          end: {
            line: 279,
            column: 31
          }
        }, {
          start: {
            line: 279,
            column: 2
          },
          end: {
            line: 279,
            column: 31
          }
        }],
        line: 279
      },
      "41": {
        loc: {
          start: {
            line: 283,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 283,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        }, {
          start: {
            line: 283,
            column: 2
          },
          end: {
            line: 285,
            column: 3
          }
        }],
        line: 283
      },
      "42": {
        loc: {
          start: {
            line: 288,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 288,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        }, {
          start: {
            line: 288,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        }],
        line: 288
      },
      "43": {
        loc: {
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 31
          }
        }, {
          start: {
            line: 297,
            column: 2
          },
          end: {
            line: 297,
            column: 31
          }
        }],
        line: 297
      },
      "44": {
        loc: {
          start: {
            line: 302,
            column: 2
          },
          end: {
            line: 304,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 302,
            column: 2
          },
          end: {
            line: 304,
            column: 3
          }
        }, {
          start: {
            line: 302,
            column: 2
          },
          end: {
            line: 304,
            column: 3
          }
        }],
        line: 302
      },
      "45": {
        loc: {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 309,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 309,
            column: 3
          }
        }, {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 309,
            column: 3
          }
        }],
        line: 307
      },
      "46": {
        loc: {
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        }, {
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        }],
        line: 312
      },
      "47": {
        loc: {
          start: {
            line: 317,
            column: 2
          },
          end: {
            line: 319,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 2
          },
          end: {
            line: 319,
            column: 3
          }
        }, {
          start: {
            line: 317,
            column: 2
          },
          end: {
            line: 319,
            column: 3
          }
        }],
        line: 317
      },
      "48": {
        loc: {
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 326,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 326,
            column: 31
          }
        }, {
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 326,
            column: 31
          }
        }],
        line: 326
      },
      "49": {
        loc: {
          start: {
            line: 331,
            column: 2
          },
          end: {
            line: 333,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 331,
            column: 2
          },
          end: {
            line: 333,
            column: 3
          }
        }, {
          start: {
            line: 331,
            column: 2
          },
          end: {
            line: 333,
            column: 3
          }
        }],
        line: 331
      },
      "50": {
        loc: {
          start: {
            line: 336,
            column: 2
          },
          end: {
            line: 338,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 336,
            column: 2
          },
          end: {
            line: 338,
            column: 3
          }
        }, {
          start: {
            line: 336,
            column: 2
          },
          end: {
            line: 338,
            column: 3
          }
        }],
        line: 336
      },
      "51": {
        loc: {
          start: {
            line: 349,
            column: 2
          },
          end: {
            line: 349,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 349,
            column: 2
          },
          end: {
            line: 349,
            column: 22
          }
        }, {
          start: {
            line: 349,
            column: 2
          },
          end: {
            line: 349,
            column: 22
          }
        }],
        line: 349
      },
      "52": {
        loc: {
          start: {
            line: 355,
            column: 2
          },
          end: {
            line: 355,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 355,
            column: 2
          },
          end: {
            line: 355,
            column: 22
          }
        }, {
          start: {
            line: 355,
            column: 2
          },
          end: {
            line: 355,
            column: 22
          }
        }],
        line: 355
      },
      "53": {
        loc: {
          start: {
            line: 362,
            column: 2
          },
          end: {
            line: 362,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 362,
            column: 2
          },
          end: {
            line: 362,
            column: 40
          }
        }, {
          start: {
            line: 362,
            column: 2
          },
          end: {
            line: 362,
            column: 40
          }
        }],
        line: 362
      },
      "54": {
        loc: {
          start: {
            line: 366,
            column: 2
          },
          end: {
            line: 368,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 366,
            column: 2
          },
          end: {
            line: 368,
            column: 3
          }
        }, {
          start: {
            line: 366,
            column: 2
          },
          end: {
            line: 368,
            column: 3
          }
        }],
        line: 366
      },
      "55": {
        loc: {
          start: {
            line: 366,
            column: 6
          },
          end: {
            line: 366,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 366,
            column: 6
          },
          end: {
            line: 366,
            column: 27
          }
        }, {
          start: {
            line: 366,
            column: 31
          },
          end: {
            line: 366,
            column: 53
          }
        }],
        line: 366
      },
      "56": {
        loc: {
          start: {
            line: 370,
            column: 2
          },
          end: {
            line: 372,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 370,
            column: 2
          },
          end: {
            line: 372,
            column: 3
          }
        }, {
          start: {
            line: 370,
            column: 2
          },
          end: {
            line: 372,
            column: 3
          }
        }],
        line: 370
      },
      "57": {
        loc: {
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 370,
            column: 106
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 370,
            column: 28
          }
        }, {
          start: {
            line: 370,
            column: 32
          },
          end: {
            line: 370,
            column: 54
          }
        }, {
          start: {
            line: 370,
            column: 58
          },
          end: {
            line: 370,
            column: 80
          }
        }, {
          start: {
            line: 370,
            column: 84
          },
          end: {
            line: 370,
            column: 106
          }
        }],
        line: 370
      },
      "58": {
        loc: {
          start: {
            line: 379,
            column: 2
          },
          end: {
            line: 379,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 379,
            column: 2
          },
          end: {
            line: 379,
            column: 40
          }
        }, {
          start: {
            line: 379,
            column: 2
          },
          end: {
            line: 379,
            column: 40
          }
        }],
        line: 379
      },
      "59": {
        loc: {
          start: {
            line: 385,
            column: 2
          },
          end: {
            line: 385,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 385,
            column: 2
          },
          end: {
            line: 385,
            column: 40
          }
        }, {
          start: {
            line: 385,
            column: 2
          },
          end: {
            line: 385,
            column: 40
          }
        }],
        line: 385
      },
      "60": {
        loc: {
          start: {
            line: 399,
            column: 12
          },
          end: {
            line: 399,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 399,
            column: 31
          },
          end: {
            line: 399,
            column: 40
          }
        }, {
          start: {
            line: 399,
            column: 43
          },
          end: {
            line: 399,
            column: 44
          }
        }],
        line: 399
      },
      "61": {
        loc: {
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 409,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 409,
            column: 23
          }
        }, {
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 409,
            column: 23
          }
        }],
        line: 409
      },
      "62": {
        loc: {
          start: {
            line: 410,
            column: 2
          },
          end: {
            line: 410,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 410,
            column: 2
          },
          end: {
            line: 410,
            column: 23
          }
        }, {
          start: {
            line: 410,
            column: 2
          },
          end: {
            line: 410,
            column: 23
          }
        }],
        line: 410
      },
      "63": {
        loc: {
          start: {
            line: 423,
            column: 36
          },
          end: {
            line: 423,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 423,
            column: 44
          },
          end: {
            line: 423,
            column: 45
          }
        }],
        line: 423
      },
      "64": {
        loc: {
          start: {
            line: 424,
            column: 2
          },
          end: {
            line: 424,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 424,
            column: 2
          },
          end: {
            line: 424,
            column: 23
          }
        }, {
          start: {
            line: 424,
            column: 2
          },
          end: {
            line: 424,
            column: 23
          }
        }],
        line: 424
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0, 0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0],
      "64": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isOne, isPercent } from './is';
var CSS_INTEGER = (cov_1kzso1457z.s[0]++, '[-\\+]?\\d+%?'); // <http://www.w3.org/TR/css3-values/#number-value>

var CSS_NUMBER = (cov_1kzso1457z.s[1]++, '[-\\+]?\\d*\\.\\d+%?');
var CSS_UNIT = (cov_1kzso1457z.s[2]++, "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")"));
var PERMISSIVE_MATCH3 = (cov_1kzso1457z.s[3]++, "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"));
var PERMISSIVE_MATCH4 = (cov_1kzso1457z.s[4]++, "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"));

var _ref = (cov_1kzso1457z.s[5]++, Math),
    floor = _ref.floor; // all color RegExp


var MATCH = (cov_1kzso1457z.s[6]++, {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb".concat(PERMISSIVE_MATCH3)),
  rgba: new RegExp("rgba".concat(PERMISSIVE_MATCH4)),
  hsl: new RegExp("hsl".concat(PERMISSIVE_MATCH3)),
  hsla: new RegExp("hsla".concat(PERMISSIVE_MATCH4)),
  hsv: new RegExp("hsv".concat(PERMISSIVE_MATCH3)),
  hsva: new RegExp("hsva".concat(PERMISSIVE_MATCH4)),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
});

function parseIntFromHex(val) {
  cov_1kzso1457z.f[0]++;
  cov_1kzso1457z.s[7]++;
  return parseInt(val, 16);
}

function convertHexToDecimal(h) {
  cov_1kzso1457z.f[1]++;
  cov_1kzso1457z.s[8]++;
  return parseIntFromHex(h) / 255;
} // string to rgba {}


cov_1kzso1457z.s[9]++;

var parse = function parse(color) {
  cov_1kzso1457z.f[2]++;
  cov_1kzso1457z.s[10]++;
  color = color.toLowerCase();
  var match;
  cov_1kzso1457z.s[11]++;

  if (match = MATCH.rgb.exec(color)) {
    cov_1kzso1457z.b[0][0]++;
    cov_1kzso1457z.s[12]++;
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  } else {
    cov_1kzso1457z.b[0][1]++;
  }

  cov_1kzso1457z.s[13]++;

  if (match = MATCH.rgba.exec(color)) {
    cov_1kzso1457z.b[1][0]++;
    cov_1kzso1457z.s[14]++;
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  } else {
    cov_1kzso1457z.b[1][1]++;
  }

  cov_1kzso1457z.s[15]++;

  if (match = MATCH.hex8.exec(color)) {
    cov_1kzso1457z.b[2][0]++;
    cov_1kzso1457z.s[16]++;
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4])
    };
  } else {
    cov_1kzso1457z.b[2][1]++;
  }

  cov_1kzso1457z.s[17]++;

  if (match = MATCH.hex6.exec(color)) {
    cov_1kzso1457z.b[3][0]++;
    cov_1kzso1457z.s[18]++;
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3])
    };
  } else {
    cov_1kzso1457z.b[3][1]++;
  }

  cov_1kzso1457z.s[19]++;

  if (match = MATCH.hex4.exec(color)) {
    cov_1kzso1457z.b[4][0]++;
    cov_1kzso1457z.s[20]++;
    return {
      r: parseIntFromHex("".concat(match[1]).concat(match[1])),
      g: parseIntFromHex("".concat(match[2]).concat(match[2])),
      b: parseIntFromHex("".concat(match[3]).concat(match[3])),
      a: convertHexToDecimal("".concat(match[4]).concat(match[4]))
    };
  } else {
    cov_1kzso1457z.b[4][1]++;
  }

  cov_1kzso1457z.s[21]++;

  if (match = MATCH.hex3.exec(color)) {
    cov_1kzso1457z.b[5][0]++;
    cov_1kzso1457z.s[22]++;
    return {
      r: parseIntFromHex("".concat(match[1]).concat(match[1])),
      g: parseIntFromHex("".concat(match[2]).concat(match[2])),
      b: parseIntFromHex("".concat(match[3]).concat(match[3]))
    };
  } else {
    cov_1kzso1457z.b[5][1]++;
  }

  cov_1kzso1457z.s[23]++;
  return false;
};

cov_1kzso1457z.s[24]++;

var toRGB = function toRGB(input) {
  cov_1kzso1457z.f[3]++;
  cov_1kzso1457z.s[25]++;

  if ((cov_1kzso1457z.b[7][0]++, !input) || (cov_1kzso1457z.b[7][1]++, typeof input !== 'string')) {
    cov_1kzso1457z.b[6][0]++;
    cov_1kzso1457z.s[26]++;
    return '';
  } else {
    cov_1kzso1457z.b[6][1]++;
  }

  var color = (cov_1kzso1457z.s[27]++, parse(input));
  cov_1kzso1457z.s[28]++;

  if (!color) {
    cov_1kzso1457z.b[8][0]++;
    cov_1kzso1457z.s[29]++;
    return '';
  } else {
    cov_1kzso1457z.b[8][1]++;
  }

  cov_1kzso1457z.s[30]++;
  return color.a ? (cov_1kzso1457z.b[9][0]++, "rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(color.a, ")")) : (cov_1kzso1457z.b[9][1]++, "rgb(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ")"));
};

cov_1kzso1457z.s[31]++;

var isString = function isString(string) {
  cov_1kzso1457z.f[4]++;
  cov_1kzso1457z.s[32]++;

  if (!string) {
    cov_1kzso1457z.b[10][0]++;
    cov_1kzso1457z.s[33]++;
    console.error(new Error('the color is empty'));
    cov_1kzso1457z.s[34]++;
    return false;
  } else {
    cov_1kzso1457z.b[10][1]++;
  }

  cov_1kzso1457z.s[35]++;

  if (typeof string !== 'string') {
    cov_1kzso1457z.b[11][0]++;
    cov_1kzso1457z.s[36]++;
    console.error(new Error("the color is get a ".concat(typeof string, ", expect string")));
    cov_1kzso1457z.s[37]++;
    return false;
  } else {
    cov_1kzso1457z.b[11][1]++;
  }

  cov_1kzso1457z.s[38]++;
  return true;
};

cov_1kzso1457z.s[39]++;

var dealPointZero = function dealPointZero(string) {
  cov_1kzso1457z.f[5]++;
  var num = (cov_1kzso1457z.s[40]++, string.toFixed(1));
  var reg = (cov_1kzso1457z.s[41]++, /\.0*$/);
  cov_1kzso1457z.s[42]++;

  if (reg.test(num)) {
    cov_1kzso1457z.b[12][0]++;
    cov_1kzso1457z.s[43]++;
    return floor(Number(num));
  } else {
    cov_1kzso1457z.b[12][1]++;
  }

  cov_1kzso1457z.s[44]++;
  return num;
};
/**
 * parse Hex to int
 * @param {*} value Hex number
 */


cov_1kzso1457z.s[45]++;

var parseHex = function parseHex(value) {
  cov_1kzso1457z.f[6]++;
  cov_1kzso1457z.s[46]++;
  return parseInt(value, 16);
};
/**
 * format the hex array
 * @param {Array} array hex array
 */


cov_1kzso1457z.s[47]++;

var formatHexArray = function formatHexArray(array, length) {
  cov_1kzso1457z.f[7]++;
  cov_1kzso1457z.s[48]++;

  if (length === 6) {
    cov_1kzso1457z.b[13][0]++;
    cov_1kzso1457z.s[49]++;
    return ["".concat(array[1]), "".concat(array[2]), "".concat(array[3])];
  } else {
    cov_1kzso1457z.b[13][1]++;
  }

  cov_1kzso1457z.s[50]++;

  if (length === 3) {
    cov_1kzso1457z.b[14][0]++;
    cov_1kzso1457z.s[51]++;
    return ["".concat(array[1]).concat(array[1]), "".concat(array[2]).concat(array[2]), "".concat(array[3]).concat(array[3])];
  } else {
    cov_1kzso1457z.b[14][1]++;
  }

  cov_1kzso1457z.s[52]++;

  if (length === 8) {
    cov_1kzso1457z.b[15][0]++;
    cov_1kzso1457z.s[53]++;
    return ["".concat(array[1]), "".concat(array[2]), "".concat(array[3]), "".concat(array[4])];
  } else {
    cov_1kzso1457z.b[15][1]++;
  }

  cov_1kzso1457z.s[54]++;
  return ["".concat(array[1]).concat(array[1]), "".concat(array[2]).concat(array[2]), "".concat(array[3]).concat(array[3]), "".concat(array[4]).concat(array[4])];
};

cov_1kzso1457z.s[55]++;

var getRgb = function getRgb(arr, length) {
  cov_1kzso1457z.f[8]++;
  var array = (cov_1kzso1457z.s[56]++, formatHexArray(arr, length));
  cov_1kzso1457z.s[57]++;
  return "rgb(".concat(parseHex(array[0]), ", ").concat(parseHex(array[1]), ", ").concat(parseHex(array[2]), ")");
};

cov_1kzso1457z.s[58]++;

var getRgba = function getRgba(arr, length) {
  cov_1kzso1457z.f[9]++;
  var array = (cov_1kzso1457z.s[59]++, formatHexArray(arr, length));
  cov_1kzso1457z.s[60]++;
  return "rgba(".concat(parseHex(array[0]), ", ").concat(parseHex(array[1]), ", ").concat(parseHex(array[2]), ", ").concat(dealPointZero(parseHex(array[3]) / 255), ")");
};

cov_1kzso1457z.s[61]++;

var toBound01 = function toBound01(val, max) {
  cov_1kzso1457z.f[10]++;
  cov_1kzso1457z.s[62]++;

  if (isOne(val)) {
    cov_1kzso1457z.b[16][0]++;
    cov_1kzso1457z.s[63]++;
    val = '100%';
  } else {
    cov_1kzso1457z.b[16][1]++;
  }

  var processPercent = (cov_1kzso1457z.s[64]++, isPercent(val));
  cov_1kzso1457z.s[65]++;
  val = Math.min(max, Math.max(0, parseInt(String(val), 10))); // Automatically convert percentage into number

  cov_1kzso1457z.s[66]++;

  if (processPercent) {
    cov_1kzso1457z.b[17][0]++;
    cov_1kzso1457z.s[67]++;
    val = parseInt(String(val * max), 10) / 100;
  } else {
    cov_1kzso1457z.b[17][1]++;
  } // Handle floating point rounding errors


  cov_1kzso1457z.s[68]++;

  if (Math.abs(val - max) < 0.000001) {
    cov_1kzso1457z.b[18][0]++;
    cov_1kzso1457z.s[69]++;
    return 1;
  } else {
    cov_1kzso1457z.b[18][1]++;
  } // Convert into [0, 1] range if it isn't already


  cov_1kzso1457z.s[70]++;
  return val % max / parseInt(String(max), 10);
};

cov_1kzso1457z.s[71]++;

var hueToRgb = function hueToRgb(p, q, t) {
  cov_1kzso1457z.f[11]++;
  cov_1kzso1457z.s[72]++;

  if (t < 0) {
    cov_1kzso1457z.b[19][0]++;
    cov_1kzso1457z.s[73]++;
    t += 1;
  } else {
    cov_1kzso1457z.b[19][1]++;
  }

  cov_1kzso1457z.s[74]++;

  if (t > 1) {
    cov_1kzso1457z.b[20][0]++;
    cov_1kzso1457z.s[75]++;
    t -= 1;
  } else {
    cov_1kzso1457z.b[20][1]++;
  }

  cov_1kzso1457z.s[76]++;

  if (t < 1 / 6) {
    cov_1kzso1457z.b[21][0]++;
    cov_1kzso1457z.s[77]++;
    return p + (q - p) * 6 * t;
  } else {
    cov_1kzso1457z.b[21][1]++;
  }

  cov_1kzso1457z.s[78]++;

  if (t < 1 / 2) {
    cov_1kzso1457z.b[22][0]++;
    cov_1kzso1457z.s[79]++;
    return q;
  } else {
    cov_1kzso1457z.b[22][1]++;
  }

  cov_1kzso1457z.s[80]++;

  if (t < 2 / 3) {
    cov_1kzso1457z.b[23][0]++;
    cov_1kzso1457z.s[81]++;
    return p + (q - p) * (2 / 3 - t) * 6;
  } else {
    cov_1kzso1457z.b[23][1]++;
  }

  cov_1kzso1457z.s[82]++;
  return p;
};

cov_1kzso1457z.s[83]++;

var translateHsl = function translateHsl(matchs, a) {
  cov_1kzso1457z.f[12]++;

  var _ref2 = (cov_1kzso1457z.s[84]++, matchs),
      _ref3 = _slicedToArray(_ref2, 4),
      h = _ref3[1],
      s = _ref3[2],
      l = _ref3[3];

  var r;
  var g;
  var b;
  cov_1kzso1457z.s[85]++;
  h = toBound01(h, 360);
  cov_1kzso1457z.s[86]++;
  s = toBound01(s, 100);
  cov_1kzso1457z.s[87]++;
  l = toBound01(l, 100);
  cov_1kzso1457z.s[88]++;

  if (s === 0) {
    cov_1kzso1457z.b[24][0]++;
    cov_1kzso1457z.s[89]++;
    r = l;
    cov_1kzso1457z.s[90]++;
    g = l;
    cov_1kzso1457z.s[91]++;
    b = l;
  } else {
    cov_1kzso1457z.b[24][1]++;
    var q = (cov_1kzso1457z.s[92]++, l < 0.5 ? (cov_1kzso1457z.b[25][0]++, l * (1 + s)) : (cov_1kzso1457z.b[25][1]++, l + s - l * s));
    var p = (cov_1kzso1457z.s[93]++, 2 * l - q);
    cov_1kzso1457z.s[94]++;
    r = hueToRgb(p, q, h + 1 / 3);
    cov_1kzso1457z.s[95]++;
    g = hueToRgb(p, q, h);
    cov_1kzso1457z.s[96]++;
    b = hueToRgb(p, q, h - 1 / 3);
  }

  cov_1kzso1457z.s[97]++;
  r = floor(r * 255);
  cov_1kzso1457z.s[98]++;
  g = floor(g * 255);
  cov_1kzso1457z.s[99]++;
  b = floor(b * 255);
  cov_1kzso1457z.s[100]++;
  return a ? (cov_1kzso1457z.b[26][0]++, "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")")) : (cov_1kzso1457z.b[26][1]++, "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")"));
};

cov_1kzso1457z.s[101]++;

var isDarkRgb = function isDarkRgb(color) {
  cov_1kzso1457z.f[13]++;
  var matchs = (cov_1kzso1457z.s[102]++, (cov_1kzso1457z.b[27][0]++, MATCH.rgb.exec(color)) || (cov_1kzso1457z.b[27][1]++, MATCH.rgba.exec(color)));
  cov_1kzso1457z.s[103]++;

  if (matchs) {
    cov_1kzso1457z.b[28][0]++;

    var _ref4 = (cov_1kzso1457z.s[104]++, matchs),
        _ref5 = _slicedToArray(_ref4, 4),
        r = _ref5[1],
        g = _ref5[2],
        b = _ref5[3];

    cov_1kzso1457z.s[105]++;
    return Number(r) * 0.299 + Number(g) * 0.578 + Number(b) * 0.114 < 192;
  } else {
    cov_1kzso1457z.b[28][1]++;
  }

  cov_1kzso1457z.s[106]++;
  console.error(new Error("the string '".concat(color, "' is not a legal color")));
  cov_1kzso1457z.s[107]++;
  return undefined;
};

cov_1kzso1457z.s[108]++;

var toHex = function toHex(rgb, noAlpha, a) {
  cov_1kzso1457z.f[14]++;

  var _ref6 = (cov_1kzso1457z.s[109]++, rgb),
      _ref7 = _slicedToArray(_ref6, 4),
      r = _ref7[1],
      g = _ref7[2],
      b = _ref7[3];

  cov_1kzso1457z.s[110]++;

  var _rgb = _slicedToArray(rgb, 4);

  r = _rgb[1];
  g = _rgb[2];
  b = _rgb[3];
  var o;
  var calAlhpa = (cov_1kzso1457z.s[111]++, (cov_1kzso1457z.b[29][0]++, !noAlpha) && (cov_1kzso1457z.b[29][1]++, a));
  cov_1kzso1457z.s[112]++;
  r = floor(r).toString(16);
  cov_1kzso1457z.s[113]++;
  g = floor(g).toString(16);
  cov_1kzso1457z.s[114]++;
  b = floor(b).toString(16);
  cov_1kzso1457z.s[115]++;

  if (r.length !== 2) {
    cov_1kzso1457z.b[30][0]++;
    cov_1kzso1457z.s[116]++;
    r = "0".concat(r);
  } else {
    cov_1kzso1457z.b[30][1]++;
  }

  cov_1kzso1457z.s[117]++;

  if (g.length !== 2) {
    cov_1kzso1457z.b[31][0]++;
    cov_1kzso1457z.s[118]++;
    g = "0".concat(g);
  } else {
    cov_1kzso1457z.b[31][1]++;
  }

  cov_1kzso1457z.s[119]++;

  if (b.length !== 2) {
    cov_1kzso1457z.b[32][0]++;
    cov_1kzso1457z.s[120]++;
    b = "0".concat(b);
  } else {
    cov_1kzso1457z.b[32][1]++;
  }

  cov_1kzso1457z.s[121]++;

  if (calAlhpa) {
    cov_1kzso1457z.b[33][0]++;
    cov_1kzso1457z.s[122]++;
    o = floor(a * 255).toString(16);
  } else {
    cov_1kzso1457z.b[33][1]++;
  }

  cov_1kzso1457z.s[123]++;
  return calAlhpa ? (cov_1kzso1457z.b[34][0]++, "#".concat(r).concat(g).concat(b).concat(o)) : (cov_1kzso1457z.b[34][1]++, "#".concat(r).concat(g).concat(b));
}; // third parameter, to keep same with toHex


cov_1kzso1457z.s[124]++;

var toHsl = function toHsl(rgb, _, a) {
  cov_1kzso1457z.f[15]++;

  var _ref8 = (cov_1kzso1457z.s[125]++, rgb),
      _ref9 = _slicedToArray(_ref8, 4),
      r = _ref9[1],
      g = _ref9[2],
      b = _ref9[3];

  cov_1kzso1457z.s[126]++;
  r = toBound01(r, 255);
  cov_1kzso1457z.s[127]++;
  g = toBound01(g, 255);
  cov_1kzso1457z.s[128]++;
  b = toBound01(b, 255);
  var max = (cov_1kzso1457z.s[129]++, Math.max(r, g, b));
  var min = (cov_1kzso1457z.s[130]++, Math.min(r, g, b));
  var h;
  var s;
  var l = (cov_1kzso1457z.s[131]++, (max + min) / 2);
  cov_1kzso1457z.s[132]++;

  if (max === min) {
    cov_1kzso1457z.b[35][0]++;
    cov_1kzso1457z.s[133]++;
    h = 0;
    cov_1kzso1457z.s[134]++;
    s = 0; // achromatic
  } else {
    cov_1kzso1457z.b[35][1]++;
    var d = (cov_1kzso1457z.s[135]++, max - min);
    cov_1kzso1457z.s[136]++;
    s = l > 0.5 ? (cov_1kzso1457z.b[36][0]++, d / (2 - max - min)) : (cov_1kzso1457z.b[36][1]++, d / (max + min));
    cov_1kzso1457z.s[137]++;

    switch (max) {
      case r:
        cov_1kzso1457z.b[37][0]++;
        cov_1kzso1457z.s[138]++;
        h = (g - b) / d + (g < b ? (cov_1kzso1457z.b[38][0]++, 6) : (cov_1kzso1457z.b[38][1]++, 0));
        cov_1kzso1457z.s[139]++;
        break;

      case g:
        cov_1kzso1457z.b[37][1]++;
        cov_1kzso1457z.s[140]++;
        h = (b - r) / d + 2;
        cov_1kzso1457z.s[141]++;
        break;

      case b:
        cov_1kzso1457z.b[37][2]++;
        cov_1kzso1457z.s[142]++;
        h = (r - g) / d + 4;
        cov_1kzso1457z.s[143]++;
        break;

      default:
        cov_1kzso1457z.b[37][3]++;
        cov_1kzso1457z.s[144]++;
        h = 0;
        cov_1kzso1457z.s[145]++;
        break;
    }

    cov_1kzso1457z.s[146]++;
    h /= 6;
  }

  cov_1kzso1457z.s[147]++;
  h = floor(h * 360);
  cov_1kzso1457z.s[148]++;
  s = floor(s * 100);
  cov_1kzso1457z.s[149]++;
  l = floor(l * 100);
  cov_1kzso1457z.s[150]++;
  return a ? (cov_1kzso1457z.b[39][0]++, "hsla(".concat(h, ", ").concat(s, ", ").concat(l, ", ").concat(a, ")")) : (cov_1kzso1457z.b[39][1]++, "hsl(".concat(h, ", ").concat(s, ", ").concat(l, ")"));
};

cov_1kzso1457z.s[151]++;

var rgbTranlate = function rgbTranlate(target) {
  cov_1kzso1457z.f[16]++;
  cov_1kzso1457z.s[152]++;
  return function (rgb, noAlpha) {
    cov_1kzso1457z.f[17]++;
    cov_1kzso1457z.s[153]++;

    if (!isString(rgb)) {
      cov_1kzso1457z.b[40][0]++;
      cov_1kzso1457z.s[154]++;
      return '';
    } else {
      cov_1kzso1457z.b[40][1]++;
    }

    var matchs;
    cov_1kzso1457z.s[155]++;
    matchs = MATCH.rgb.exec(rgb);
    cov_1kzso1457z.s[156]++;

    if (matchs) {
      cov_1kzso1457z.b[41][0]++;
      cov_1kzso1457z.s[157]++;
      return target(matchs, noAlpha);
    } else {
      cov_1kzso1457z.b[41][1]++;
    }

    cov_1kzso1457z.s[158]++;
    matchs = MATCH.rgba.exec(rgb);
    cov_1kzso1457z.s[159]++;

    if (matchs) {
      cov_1kzso1457z.b[42][0]++;
      cov_1kzso1457z.s[160]++;
      return target(matchs, noAlpha, Number(matchs[4]));
    } else {
      cov_1kzso1457z.b[42][1]++;
    }

    cov_1kzso1457z.s[161]++;
    console.error(new Error("the string '".concat(rgb, "' is not a rgb color")));
    cov_1kzso1457z.s[162]++;
    return '';
  };
};

export function hexToRgb(hex) {
  cov_1kzso1457z.f[18]++;
  cov_1kzso1457z.s[163]++;

  if (!isString(hex)) {
    cov_1kzso1457z.b[43][0]++;
    cov_1kzso1457z.s[164]++;
    return '';
  } else {
    cov_1kzso1457z.b[43][1]++;
  }

  var matchs;
  cov_1kzso1457z.s[165]++;
  matchs = MATCH.hex3.exec(hex);
  cov_1kzso1457z.s[166]++;

  if (matchs) {
    cov_1kzso1457z.b[44][0]++;
    cov_1kzso1457z.s[167]++;
    return getRgb(matchs, 3);
  } else {
    cov_1kzso1457z.b[44][1]++;
  }

  cov_1kzso1457z.s[168]++;
  matchs = MATCH.hex6.exec(hex);
  cov_1kzso1457z.s[169]++;

  if (matchs) {
    cov_1kzso1457z.b[45][0]++;
    cov_1kzso1457z.s[170]++;
    return getRgb(matchs, 6);
  } else {
    cov_1kzso1457z.b[45][1]++;
  }

  cov_1kzso1457z.s[171]++;
  matchs = MATCH.hex4.exec(hex);
  cov_1kzso1457z.s[172]++;

  if (matchs) {
    cov_1kzso1457z.b[46][0]++;
    cov_1kzso1457z.s[173]++;
    return getRgba(matchs, 4);
  } else {
    cov_1kzso1457z.b[46][1]++;
  }

  cov_1kzso1457z.s[174]++;
  matchs = MATCH.hex8.exec(hex);
  cov_1kzso1457z.s[175]++;

  if (matchs) {
    cov_1kzso1457z.b[47][0]++;
    cov_1kzso1457z.s[176]++;
    return getRgba(matchs, 8);
  } else {
    cov_1kzso1457z.b[47][1]++;
  }

  cov_1kzso1457z.s[177]++;
  console.error(new Error("the string '".concat(hex, "' is not a hex color")));
  cov_1kzso1457z.s[178]++;
  return '';
}
export function hslToRgb(hsl) {
  cov_1kzso1457z.f[19]++;
  cov_1kzso1457z.s[179]++;

  if (!isString(hsl)) {
    cov_1kzso1457z.b[48][0]++;
    cov_1kzso1457z.s[180]++;
    return '';
  } else {
    cov_1kzso1457z.b[48][1]++;
  }

  var matchs;
  cov_1kzso1457z.s[181]++;
  matchs = MATCH.hsl.exec(hsl);
  cov_1kzso1457z.s[182]++;

  if (matchs) {
    cov_1kzso1457z.b[49][0]++;
    cov_1kzso1457z.s[183]++;
    return translateHsl(matchs);
  } else {
    cov_1kzso1457z.b[49][1]++;
  }

  cov_1kzso1457z.s[184]++;
  matchs = MATCH.hsla.exec(hsl);
  cov_1kzso1457z.s[185]++;

  if (matchs) {
    cov_1kzso1457z.b[50][0]++;
    cov_1kzso1457z.s[186]++;
    return translateHsl(matchs, matchs[4]);
  } else {
    cov_1kzso1457z.b[50][1]++;
  }

  cov_1kzso1457z.s[187]++;
  console.error(new Error("the string '".concat(hsl, "' is not a hsl color")));
  cov_1kzso1457z.s[188]++;
  return '';
}
export var rgbToHex = (cov_1kzso1457z.s[189]++, rgbTranlate(toHex));
export var rgbTohsl = (cov_1kzso1457z.s[190]++, rgbTranlate(toHsl));
export function hexToHsl(hex) {
  cov_1kzso1457z.f[20]++;
  var temp = (cov_1kzso1457z.s[191]++, hexToRgb(hex));
  cov_1kzso1457z.s[192]++;

  if (!temp) {
    cov_1kzso1457z.b[51][0]++;
    cov_1kzso1457z.s[193]++;
    return '';
  } else {
    cov_1kzso1457z.b[51][1]++;
  }

  cov_1kzso1457z.s[194]++;
  return rgbTohsl(temp);
}
export function hslToHex(hsl, noAlpha) {
  cov_1kzso1457z.f[21]++;
  var temp = (cov_1kzso1457z.s[195]++, hslToRgb(hsl));
  cov_1kzso1457z.s[196]++;

  if (!temp) {
    cov_1kzso1457z.b[52][0]++;
    cov_1kzso1457z.s[197]++;
    return '';
  } else {
    cov_1kzso1457z.b[52][1]++;
  }

  cov_1kzso1457z.s[198]++;
  return rgbToHex(temp, noAlpha);
} // dark or light

export function judgeDark(color) {
  cov_1kzso1457z.f[22]++;
  cov_1kzso1457z.s[199]++;

  if (!isString(color)) {
    cov_1kzso1457z.b[53][0]++;
    cov_1kzso1457z.s[200]++;
    return undefined;
  } else {
    cov_1kzso1457z.b[53][1]++;
  }

  var rgbString = (cov_1kzso1457z.s[201]++, color);
  cov_1kzso1457z.s[202]++;

  if ((cov_1kzso1457z.b[55][0]++, MATCH.hsl.test(color)) || (cov_1kzso1457z.b[55][1]++, MATCH.hsla.test(color))) {
    cov_1kzso1457z.b[54][0]++;
    cov_1kzso1457z.s[203]++;
    rgbString = hslToRgb(color);
  } else {
    cov_1kzso1457z.b[54][1]++;
  }

  cov_1kzso1457z.s[204]++;

  if ((cov_1kzso1457z.b[57][0]++, MATCH.hex3.test(color)) || (cov_1kzso1457z.b[57][1]++, MATCH.hex4.test(color)) || (cov_1kzso1457z.b[57][2]++, MATCH.hex6.test(color)) || (cov_1kzso1457z.b[57][3]++, MATCH.hex8.test(color))) {
    cov_1kzso1457z.b[56][0]++;
    cov_1kzso1457z.s[205]++;
    rgbString = hexToRgb(color);
  } else {
    cov_1kzso1457z.b[56][1]++;
  }

  cov_1kzso1457z.s[206]++;
  return isDarkRgb(rgbString);
}
export function isDark(color) {
  cov_1kzso1457z.f[23]++;
  var result = (cov_1kzso1457z.s[207]++, judgeDark(color));
  cov_1kzso1457z.s[208]++;

  if (result === undefined) {
    cov_1kzso1457z.b[58][0]++;
    cov_1kzso1457z.s[209]++;
    return false;
  } else {
    cov_1kzso1457z.b[58][1]++;
  }

  cov_1kzso1457z.s[210]++;
  return result;
}
export function isLight(color) {
  cov_1kzso1457z.f[24]++;
  var result = (cov_1kzso1457z.s[211]++, judgeDark(color));
  cov_1kzso1457z.s[212]++;

  if (result === undefined) {
    cov_1kzso1457z.b[59][0]++;
    cov_1kzso1457z.s[213]++;
    return false;
  } else {
    cov_1kzso1457z.b[59][1]++;
  }

  cov_1kzso1457z.s[214]++;
  return !result;
}
/**
 * get hsla h s l a
 * @param color hsl
 */

function getHSLA(color) {
  cov_1kzso1457z.f[25]++;
  var hslReg = (cov_1kzso1457z.s[215]++, new RegExp(/hsla?\((\d{1,3}), (\d{1,3}), (\d{1,3})(, (\d{1,3}))?\)$/));
  cov_1kzso1457z.s[216]++;
  hslReg.test(color);
  var h = (cov_1kzso1457z.s[217]++, RegExp.$1);
  var s = (cov_1kzso1457z.s[218]++, RegExp.$2);
  var l = (cov_1kzso1457z.s[219]++, RegExp.$3);
  var a = (cov_1kzso1457z.s[220]++, RegExp.$5.length ? (cov_1kzso1457z.b[60][0]++, RegExp.$5) : (cov_1kzso1457z.b[60][1]++, 1));
  cov_1kzso1457z.s[221]++;
  return {
    h: h,
    s: s,
    l: parseInt(l, 10),
    a: a
  };
}
/**
 * darken color
 * @param color format rgb | rgba
 * @param value -100 ~ 100
 */


export function darken(color, value) {
  cov_1kzso1457z.f[26]++;
  cov_1kzso1457z.s[222]++;

  if (!color) {
    cov_1kzso1457z.b[61][0]++;
    cov_1kzso1457z.s[223]++;
    return '';
  } else {
    cov_1kzso1457z.b[61][1]++;
  }

  cov_1kzso1457z.s[224]++;

  if (!value) {
    cov_1kzso1457z.b[62][0]++;
    cov_1kzso1457z.s[225]++;
    value = 0;
  } else {
    cov_1kzso1457z.b[62][1]++;
  }

  cov_1kzso1457z.s[226]++;
  value = parseInt(String(value), 10);
  cov_1kzso1457z.s[227]++;
  color = toRGB(color);
  var hsl = (cov_1kzso1457z.s[228]++, rgbTohsl(color));

  var _ref10 = (cov_1kzso1457z.s[229]++, getHSLA(hsl)),
      h = _ref10.h,
      s = _ref10.s,
      l = _ref10.l,
      a = _ref10.a;

  cov_1kzso1457z.s[230]++;
  return hslToRgb("hsla(".concat(h, ",").concat(s, "%,").concat(l - value, "%,").concat(a, ")"));
}
/**
 * fade color
 * @param color format rgb
 * @param alpha 0-1
 */

export function fade(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1kzso1457z.b[63][0]++, 1);
  cov_1kzso1457z.f[27]++;
  cov_1kzso1457z.s[231]++;

  if (!color) {
    cov_1kzso1457z.b[64][0]++;
    cov_1kzso1457z.s[232]++;
    return '';
  } else {
    cov_1kzso1457z.b[64][1]++;
  }

  cov_1kzso1457z.s[233]++;
  color = toRGB(color);
  var hsl = (cov_1kzso1457z.s[234]++, rgbTohsl(color));

  var _ref11 = (cov_1kzso1457z.s[235]++, getHSLA(hsl)),
      h = _ref11.h,
      s = _ref11.s,
      l = _ref11.l;

  cov_1kzso1457z.s[236]++;
  return hslToRgb("hsla(".concat(h, ",").concat(s, "%,").concat(l, "%,").concat(alpha, ")"));
}